import { Box } from '@chakra-ui/react';
import { Button } from '@mesh.ai/rabbit';

import { DrawerFooter } from 'uiToolkitV1/BottomDrawer';

type CompetencyFooterProps = {
  onClose: () => void;
};

export const CompetencyFooter = ({ onClose }: CompetencyFooterProps) => (
  <Box borderRadius="0 0 8px 8px" overflow="hidden">
    <DrawerFooter backgroundColor="#EBEFF3">
      <Button variant="filled" onClick={onClose} disabled={false}>
        Close
      </Button>
    </DrawerFooter>
  </Box>
);
